import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { BookOpen, Clock } from 'lucide-react';

const KnowledgeBase = () => {
  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-slate-800">Knowledge Base</h1>
        <p className="text-slate-600 mt-1">Create and manage documentation articles</p>
      </div>

      <Card className="shadow-sm border-slate-200">
        <CardContent className="py-20 text-center">
          <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <BookOpen className="w-10 h-10 text-blue-600" />
          </div>
          <h3 className="text-2xl font-semibold text-slate-700 mb-2">Knowledge Base Coming Soon</h3>
          <p className="text-slate-500 mb-6 max-w-md mx-auto">
            Full documentation system with:
            <br />• Rich text article editor
            <br />• Category organization
            <br />• Search functionality
            <br />• Public & internal articles
          </p>
          <div className="flex items-center justify-center space-x-2 text-sm text-slate-400">
            <Clock className="w-4 h-4" />
            <span>Under Development</span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default KnowledgeBase;
